import { ViewEncapsulation, Component, Input, HostBinding, OnInit } from '@angular/core';
import { fadeInFadeOut } from '@app/shared/animations';

@Component({
  standalone: false,
  selector: 'ti-spinner',
  templateUrl: './spinner.component.html',
  styleUrls: ['./spinner.component.scss'],
  animations: [fadeInFadeOut],
  encapsulation: ViewEncapsulation.None,
})
export class SpinnerComponent implements OnInit {
  @Input() zIndex: number;
  @Input() text: string;
  @HostBinding('style.z-index') zIndexValue: number;

  ngOnInit() {
    this.zIndexValue = this.zIndex || 99999;
  }
}
